// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"615":"a4a252a1","726":"a4a252a1","813":"2a2f00cf"}[chunkId] + ".chunk.css";
};